export class RequestListResponse {
    public totalCount: number;
    public data: RequestListItem[];
}

export class RequestListItem {
    public id: number;
    public requestType: number;
    public date: Date;
    public programName: string;
    public personName: string;
    public email: string;
    public phone: string;
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/models/requests/request-list-response.ts